// The element for `selector` when it is on screen with a size, else null.
export function visibleElement(selector) {
  if (!selector) return null
  const el = document.querySelector(selector)
  if (!el) return null
  const rect = el.getBoundingClientRect()
  return rect.width > 0 && rect.height > 0 ? el : null
}

// "/code/anything" -> "/code"
export function routeOf(pathname) {
  return `/${(pathname || '').split('/')[1] || ''}`
}

export function modalOpen() {
  return Boolean(document.querySelector('.ct-modal-overlay'))
}
